const styles = ({ COLORS }) => ({
  container: {
    marginTop: '30px',
    '& a': {
      color: '#008bec',
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  },
  content: {
    minWidth: '50%'
  },
  status: {
    display: 'flex',
    margin: '30px 0 20px',
    '& p a': {
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  },
  title: {
    margin: 0
  },
  select: {
    minWidth: '340px',
    marginLeft: '20px'
  },
  selection: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  field: {
    minWidth: '340px',
    height: '40px',
    border: '1px solid #ddd',
    padding: '10px 15px',
    borderRadius: '4px',
    color: '#999',
    marginTop: '10px',
    '&::placeholder': {
      color: '#bbb'
    }
  },
  menu: {
    background: '#fff',
    boxShadow: '0 0 4px rgba(0,0,0,0.2)',
    position: 'absolute',
    width: '100%',
    zIndex: '100'
  },
  item: {
    padding: '5px 15px'
  },
  highlighted: {
    background: COLORS.BLUE.NORMAL,
    color: '#fff',
    cursor: 'pointer'
  },
  addressField: {
    overflow: 'hidden',
    width: '100%'
  },
  addressInput: {
    float: 'right',
    maxWidth: '340px',
    marginTop: '10px',
    '& + svg': {
      top: '24px'
    }
  },
  label: {
    margin: 0
  },
  info: {
    color: COLORS.RED.NORMAL,
    marginRight: '5px'
  }
})

export default styles
